import React, { memo, useContext, useMemo } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Container } from '@mui/material'
import { AppContext } from '../context'
import { curateRoutes } from './AppRouter.hooks'
import { AppRouterProps } from './AppRouter.types'
import { RouteItem } from './RouteItem.types'

function AppRouter({ routes }: AppRouterProps) {
    const context = useContext(AppContext)

    const mappings = useMemo<RouteItem[]>(() => {
        const curated = curateRoutes(context, routes)

        return curated.flatMap((route) => {
            if (route.path) {
                return [route]
            }

            return route.items?.filter((subroute) => !!subroute.path) ?? []
        })
    }, [context, routes])

    // primera ruta visible y sin parámetros
    const fixedRoute = useMemo(() => {
        return mappings
            .filter((el) => !el.hidden)
            .find((el) => el.path && el.path.indexOf(':') === -1)
    }, [mappings])

    const redirectTo = useMemo(() => fixedRoute?.path || '/', [fixedRoute])

    return (
        <Container maxWidth={false}>
            <Switch>
                {mappings.map((route, index) => (
                    <Route
                        key={index}
                        exact={route.exact}
                        path={route.path}
                        component={route.component}
                    />
                ))}
                <Redirect from="/*" to={redirectTo} />
            </Switch>
        </Container>
    )
}

export default memo(AppRouter)
